export default __webpack_public_path__ + "static/media/ikea-device-02.657ef130.png";